import { dinero, fecha, numero, useTraduccion } from '@tallerya/i18n';
import { diaLocal, hoy, montoDe, type MontoGasto } from './datos';

/**
 * Cómo se lee un gasto en una lista, igual en la sección de la orden y en el
 * listado: el día —«hoy», o la fecha— y el monto con la moneda del taller.
 */
export function useFormatoGasto() {
  const { t, idioma } = useTraduccion();

  return {
    /** «hoy», o el día: la compra casi siempre es de hoy, y así se lee de un vistazo. */
    dia: (texto: string) => (texto === hoy() ? t('admin.gastos.hoy') : fecha(diaLocal(texto), idioma)),
    /** El monto con su moneda, o `null` si el gasto no tiene. Sin moneda no se inventa una. */
    cifra: (monto: MontoGasto) => {
      const n = montoDe(monto.amount);
      if (n === null) return null;
      return monto.currencyCode ? dinero(n, monto.currencyCode, idioma) : numero(n, idioma);
    },
  };
}
